    <template>
        <div class="ele-body">
            <el-card shadow="never" body-style="padding-top: 5px;">
                <!-- 编辑弹窗 -->
                <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">
                    <el-form-item label="活动状态:" prop="rule_status">
                        <el-select v-model="editForm.rule_status" filterable placeholder="请选择活动状态">
                            <el-option label="关闭" value="2"></el-option>
                            <el-option label="开启" value="3"></el-option>
                        </el-select>
                    </el-form-item>


                    <el-form-item label="活动规则:" prop="rule_content">
                        <tinymce-editor v-model="editForm.rule_content" :init="initEditor" />
                    </el-form-item>
                    <el-form-item label="抽奖金额:" prop="rule_price">
                        <el-input-number v-model="editForm.rule_price" controls-position="right" :min="0"
                            :controls="false" :precision="2" class="ele-fluid ele-text-left"
                            placeholder="请输入抽奖金额" clearable />
                    </el-form-item>
                    <el-form-item label="抽奖积分:" prop="rule_integral">
                        <el-input-number v-model="editForm.rule_integral" controls-position="right" :min="0"
                            :controls="false" :precision="2" class="ele-fluid ele-text-left"
                            placeholder="请输入抽奖积分" clearable />
                    </el-form-item>
                    <el-form-item label="中奖概率:" prop="rule_not_grade">
                        <el-input v-model="editForm.rule_not_grade" placeholder="请输入中奖概率" clearable />
                    </el-form-item>
                    <el-form-item label="新人免费次数:" prop="rule_num">
                        <el-input-number v-model="editForm.rule_num" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入新人免费次数" clearable />
                    </el-form-item>

                    <el-form-item label="活动开始时间:" prop="rule_start_time">
                        <el-date-picker v-model="editForm.rule_start_time" type="datetime" placeholder="选择活动开始时间"
                            size="small" value-format="yyyy-MM-dd hh:mm:ss">
                        </el-date-picker>

                    </el-form-item>

                    <el-form-item label="活动结束时间:" prop="rule_end_time">
                        <el-date-picker v-model="editForm.rule_end_time" type="datetime" placeholder="选择活动结束时间"
                            size="small" value-format="yyyy-MM-dd hh:mm:ss">
                        </el-date-picker>

                    </el-form-item>

                    <el-form-item label="兑奖结束时间:" prop="rule_over_time">
                        <el-date-picker v-model="editForm.rule_over_time" type="datetime" placeholder="选择兑奖结束时间"
                            size="small" value-format="yyyy-MM-dd hh:mm:ss">
                        </el-date-picker>

                    </el-form-item>
                    
                    <el-form-item label="到店兑换:" prop="rule_shop_exch">
                        <el-select v-model="editForm.rule_shop_exch" filterable placeholder="请选择到店兑换">
                            <el-option label="关闭" value="2"></el-option>
                            <el-option label="开启" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item label="是否邮寄:" prop="rule_post_exch">
                        <el-select v-model="editForm.rule_post_exch" filterable placeholder="请选择是否邮寄">
                            <el-option label="关闭" value="2"></el-option>
                            <el-option label="开启" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    
                    <el-form-item label="分享图片:" prop="rule_share_img">
                        <ele-uploadimage :limit="1" v-model="editForm.rule_share_img"></ele-uploadimage>
                    </el-form-item>
                    
                    <el-form-item label="活动标题:" prop="rule_title">
                        <el-input v-model="editForm.rule_title" placeholder="请输入活动标题" clearable />
                    </el-form-item>
                    <el-form-item label="转发标题:" prop="rule_forward">
                        <el-input v-model="editForm.rule_forward" placeholder="请输入转发标题" clearable />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="save">保存更改</el-button>
                    </el-form-item>
                </el-form>

            </el-card>
        </div>
    </template>

    <script>
        import {
            mapGetters
        } from "vuex";

        import EleUploadimage from '@/components/EleUploadimage'
        import TinymceEditor from '@/components/TinymceEditor'

        export default {
            name: "SysActivityTurntableRule",
            components: {
                EleUploadimage,
                TinymceEditor,
            },
            data() {
                return {
                    table: {
                        url: '/activity/ActivityTurntableRule/index',
                        where: {
                            "rule_share_img": []
                        }
                    }, // 表格配置
                    choose: [], // 表格选中数据
                    showEdit: false, // 是否显示表单弹窗
                    editForm: {
                        "rule_share_img": []
                    }, // 表单数据
                    editFormTemp: {
                        "rule_share_img": []
                    },
                    admin_list: [],
                    user_list: [],
                    search_show: false,
                    editRules: { // 表单验证规则

                        rule_status: [{
                            required: true,
                            message: '请选择活动状态',
                            trigger: 'blur'
                        }],


                        rule_content: [{
                            required: true,
                            message: '请输入活动规则',
                            trigger: 'blur'
                        }],
                        rule_price: [{
                            required: true,
                            message: '请输入抽奖所需金额',
                            trigger: 'blur'
                        }],
                        rule_integral: [{
                            required: true,
                            message: '请输入抽奖所需积分',
                            trigger: 'blur'
                        }],

                        rule_full: [{
                            required: true,
                            message: '请输入满多少钱可增加抽奖次数',
                            trigger: 'blur'
                        }],


                        rule_not_grade: [{
                            required: true,
                            message: '请输入中奖概率',
                            trigger: 'blur'
                        }],


                        rule_num: [{
                            required: true,
                            message: '请输入默认次数',
                            trigger: 'blur'
                        }],


                        rule_start_time: [{
                            required: true,
                            message: '请选择活动开始时间',
                            trigger: 'blur'
                        }],


                        rule_end_time: [{
                            required: true,
                            message: '请选择结束时间',
                            trigger: 'blur'
                        }],


                        rule_over_time: [{
                            required: true,
                            message: '请选择兑奖结束时间',
                            trigger: 'blur'
                        }],


                        rule_password: [{
                            required: true,
                            message: '请输入兑奖码',
                            trigger: 'blur'
                        }],


                        rule_shop_exch: [{
                            required: true,
                            message: '请选择到店兑换',
                            trigger: 'blur'
                        }],


                        rule_post_exch: [{
                            required: true,
                            message: '请选择是否邮寄',
                            trigger: 'blur'
                        }],


                        rule_number: [{
                            required: true,
                            message: '请输入参与人数',
                            trigger: 'blur'
                        }],


                        rule_share_img: [{
                            required: true,
                            message: '请上传分享图片',
                            trigger: 'blur'
                        }],


                        rule_title: [{
                            required: true,
                            message: '请输入活动标题',
                            trigger: 'blur'
                        }],


                        rule_forward: [{
                            required: true,
                            message: '请输入转发标题',
                            trigger: 'blur'
                        }],


                        create_time: [{
                            required: true,
                            message: '请选择创建时间',
                            trigger: 'blur'
                        }],


                    },
                }
            },
            computed: {
                ...mapGetters(["permission"]),
                initEditor() {
                    return {
                        height: 400,
                        file_picker_callback: this.file_picker_callback,
                        skin_url: this.$store.state.theme.theme === 'dark' ? '/tinymce/skins/ui/oxide-dark' :
                            '/tinymce/skins/ui/oxide',
                        content_css: this.$store.state.theme.theme === 'dark' ?
                            '/tinymce/skins/content/dark/content.css' : '/tinymce/skins/content/default/content.css',
                        images_upload_handler: (blobInfo, success, error) => {
                            let file = blobInfo.blob();
                            // 使用axios上传
                            const formData = new FormData();
                            formData.append('file', file, file.name);
                            this.$http.post('/upload/uploadImage', formData).then(res => {
                                if (res.data.code == 0) {
                                    success(res.data.data);
                                } else {
                                    error(res.data.msg);
                                }
                            }).catch(e => {
                                error(e.message);
                            });
                        }
                    };
                }
            },
            mounted() {
                this.edit();
            },
            methods: {

                /**
                 * 关闭
                 */
                closeDialog() {
                    this.showEdit = false;
                    this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
                },
                /**
                 * 显示编辑
                 */
                edit() {
                    this.$http.get('/activity/ActivityTurntableRule/info?id=1').then(res => {
                        if (res.data.code === 0) {
                            this.showEdit = true;
                            setTimeout(() => {
                                this.editForm = res.data.data;
                            }, 100);
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                /**
                 * 保存编辑
                 */
                save() {
                    this.$refs['editForm'].validate((valid) => {
                        if (valid) {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/activity/ActivityTurntableRule/edit', this.editForm).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.showEdit = false;
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        } else {
                            return false;
                        }
                    });
                },
                /**
                 * 刪除(批量刪除)
                 */
                remove(row) {
                    console.log(row)
                    if (!row) { // 批量删除
                        if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                        let ids = this.choose.map(d => d.id);
                        this.$confirm('确定要删除选中的大转盘活动规则吗?', '提示', {
                            type: 'warning'
                        }).then(() => {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/activity/ActivityTurntableRule/delete', {
                                id: ids
                            }).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        }).catch(() => 0);
                    } else { // 单个删除
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/activity/ActivityTurntableRule/delete', {
                            id: row.id
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }
                },

                /* 导出数据Excel */
                exportExcel() {
                    let ids = this.choose.map(d => d.id)
                    if (ids.length == 0) {
                        this.$message.error('请选择要导出的数据');
                        return false;
                    }
                    this.$http
                        .post("/activity/ActivityTurntableRule/exportExcel", {
                            id: ids
                        })
                        .then((res) => {
                            let data = res.data;
                            if (data.code == 0) {
                                // 下载文件
                                window.location.href = data.data;
                                this.$message({
                                    type: "success",
                                    message: "导出成功",
                                });
                            } else {
                                this.$message.error("导出失败");
                            }
                        })
                },


            }
        }
    </script>

    <style scoped>
        .ele-block>>>.el-upload,
        .ele-block>>>.el-upload-dragger {
            width: 100%;
        }
    </style>